import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => {
  const token = theme.partnerComponents.customButton;
  return {
    outlined: {
      minWidth: 134,
      height: 48,
      border: `solid 1px ${theme.palette.primary.main}`,
      fontWeight: 700,
      textTransform: 'none',
      marginTop: theme.spacing(2),
    },
    contained: {
      minWidth: 134,
      height: 48,
      textTransform: token.textTransform || 'none',
      marginTop: theme.spacing(2),
      fontWeight: 700,
      boxShadow: 'none !important',
      '&.MuiButton-containedPrimary': {
        backgroundColor: (props) =>
          props.error ? '#CD0000' : token.background,

        '&:hover': {
          backgroundColor: (props) =>
            props.error ? '#AF0000' : token.background,
          filter: 'brightness(85%)',
        },
      },
      '&.Mui-disabled': {
        backgroundColor: theme.palette.primary.light,
        color: theme.appColors.white,
        opacity: 0.4,
      },
      '& p': {
        color: token.text,
        fontFamily: 'BancoDoBrasilTitulos',
        fontSize: 14,
        lineHeight: '20px',
        letterSpacing: '0.66px',
        textAlign: 'center',
        fontWeight: 500,
      },
    },
    content: {
      width: '100%',
    },
  };
});
